import { generatePath, Redirect, Switch, useLocation, useParams, Route } from 'react-router-dom';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import Lesson from './routes/Lesson';
// @ts-expect-error Could not find a declaration file for module
import DashboardPageLayoutRoute from './components/Layouts/DashboardPageLayoutRoute';
import Homepage from './routes/Homepage';

// @ts-expect-error Could not find a declaration file for module
import TrackPageRouter from './containers/TrackPage/TrackPageRouter';
import Catalog from './routes/Catalog';
import { RESULTS_URL_FRAGMENT, PAGE_NAMES, TRACKS_URL_FRAGMENT, PARTNER_TRACKS_URL_FRAGMENT, WIZARD_URL_FRAGMENT, LEGACY_WATCH_LATER_URL_FRAGMENT, WATCH_LATER_URL_FRAGMENT, MY_PLAYLISTS_URL_FRAGMENT, CREATE_PLAYLIST_URL_FRAGMENT, SAVED_ITEMS_URL_FRAGMENT, PLAYLIST_URL_FRAGMENT, PLAYLIST_RESULTS_URL_FRAGMENT, PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT, DUPLICATE_PLAYLIST_URL_FRAGMENT, EDIT_PLAYLIST_URL_FRAGMENT, ASSIGN_PLAYLIST_URL_FRAGMENT, LEGACY_AWARD_URL_FRAGMENT, LEGACY_SHARE_AWARD_URL_FRAGMENT, AWARD_URL_FRAGMENT, SHARE_AWARD_URL_FRAGMENT, SHARE_AWARD_PREVIEW_URL_FRAGMENT, SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS, HUBSPOT_PLAYLISTS_ADMIN_URL_FRAGMENT, MY_TEAM_URL_FRAGMENT, PROFILE_URL_FRAGMENT, MY_TEAM_CERTIFICATIONS_URL_FRAGMENT, MY_TEAM_MEMBERS_URL_FRAGMENT, PRACTICE_MODE_URL_FRAGMENT } from './constants/Navigation';
// @ts-expect-error Could not find a declaration file for module
import TrackAwardModalContainer from './containers/TracksPage/TrackAwardModalContainer';
// @ts-expect-error Could not find a declaration file for module
import EngagementTracking from './EngagementTracking';
import NewUserLanding from './components/Landing/NewUserLanding';
import AchievementPreviewModal from './components/Modals/AchievementPreviewModal';
import { HUBSPOT_SOFTWARE_INDEX } from './features/wizard';
import AwardShareControls from './components/AwardShareControls';
import SavedItemsLayout from './components/Layouts/SavedItemsLayout';
import MyPlaylists from './routes/MyPlaylists';
import Playlist from './routes/Playlist';
import enviro from 'enviro';
import CreatePlaylist from './routes/CreatePlaylist';
import { useShowDevtools } from './features/devtools/devtoolsQueries';
import EditPlaylist from './routes/EditPlaylist';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import DuplicatePlaylist from './routes/DuplicatePlaylist';
import AssignPlaylist from './routes/AssignPlaylist';
import { MY_PLAYLISTS_TABS } from './features/myPlaylists';
import { ShortContentRoute } from './routes/ShortContent';
import { NamedRoute } from './features/routing';
import { MyLearningRoutePath, MyLearningTabs } from './features/myLearning';
import { getOverviewModalParams } from 'academy-common-lib/utils/url';
import { SoftwareDiscoveryIframe } from './features/toolRecommendations';
import Wizard from './routes/Wizard';
import HubspotPlaylistsAdmin from './features/hubspotPlaylists/components/hubspotPlaylistsAdmin/HubspotPlaylistsAdminMainPage';
import MyTeamOverview from './features/myTeam/routes/MyTeamOverview';
import MyTeamCertificationsIndex from './features/myTeam/routes/MyTeamCertificationsIndex';
import MyTeamMembers from './features/myTeam/routes/MyTeamMembers';
import { MyProfile, UserProfile, EditProfile } from './routes/Profile';
import MyTeamCertificationProfile, { RedirectToCertificationProfileDefaultTab } from './features/myTeam/routes/MyTeamCertificationProfile';
import MyTeamCertificationsByTeam, { RedirectToCertificationsByTeamDefaultTab } from './features/myTeam/routes/MyTeamCertificationsByTeam';
import ReactRouterScrollToTop from 'academy-common-lib/components/routing/ReactRouterScrollToTop';
import WatchLater from './routes/WatchLater';
import { RedirectToMyTeamOverview } from './features/myTeam/routes/MyTeamOverview';
import { LEGACY_MY_TEAM_URL_FRAGMENT } from './features/myTeam/constants/routes';
import { PracticeMode } from './features/practiceMode/PracticeMode';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const RedirectToTracksWithQueryParams = () => {
  const location = useLocation();
  const {
    pathname,
    search
  } = location;
  if (/cat=|tools=|awardType=|level=|duration=|contentType=|language=/i.test(search)) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: Object.assign({}, location, {
        pathname: RESULTS_URL_FRAGMENT
      })
    });
  }
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: pathname.replace('/tracks', '')
    })
  });
};
const RedirectToAward = () => {
  const location = useLocation();
  const {
    pathname
  } = location;
  const {
    trackId,
    awardName
  } = useParams();
  const legacyPath = generatePath(LEGACY_AWARD_URL_FRAGMENT, {
    trackId,
    awardName
  });
  const newPath = generatePath(AWARD_URL_FRAGMENT, {
    trackId
  });
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: pathname.replace(legacyPath, newPath)
    })
  });
};
const RedirectToAwardShare = () => {
  const location = useLocation();
  const {
    pathname
  } = location;
  const {
    trackId,
    awardName
  } = useParams();
  const legacyPath = generatePath(LEGACY_SHARE_AWARD_URL_FRAGMENT, {
    trackId,
    awardName
  });
  const newPath = generatePath(SHARE_AWARD_URL_FRAGMENT, {
    trackId
  });
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: pathname.replace(legacyPath, newPath)
    })
  });
};
const RedirectToWatchLater = () => {
  const location = useLocation();
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: WATCH_LATER_URL_FRAGMENT
    })
  });
};
const LEGACY_OVERVIEW_URL = ':prefix(.*)/:type(course-overview|lesson-overview|short-overview)/:id/:source?/:language?';
const RedirectToNewOverview = () => {
  const location = useLocation();
  const {
    prefix,
    type,
    id,
    source,
    language
  } = useParams();
  const search = new URLSearchParams(location.search);
  const newParams = getOverviewModalParams({
    id: Number(id),
    type: type === 'course-overview' ? 'TRACK' : type === 'lesson-overview' ? 'LESSON' : 'SHORT_FORM_CONTENT',
    language,
    source
  });
  Object.entries(newParams).forEach(([key, value]) => {
    search.set(key, value);
  });
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: prefix,
      search: `?${search}`
    })
  });
};
const PartnerPage = Loadable({
  loader: () => import( /* webpackChunkName: "bundles/partners" */
  './routes/Partners').then(mod => mod.default)
});
const QaOnlyRoutes = Loadable({
  loader: () => import( /* webpackChunkName: "bundles/qaOnly" */'./components/QaOnly/QaOnlyRoutes').then(mod => mod.default)
});
const Devtools = Loadable({
  loader: () => import( /* webpackChunkName: "bundles/devtools" */'./features/devtools').then(mod => mod.Devtools)
});
const RemoveTrailingSlash = () => {
  const location = useLocation();
  const {
    pathname
  } = location;
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: pathname.replace(/\/+$/, '')
    })
  });
};
const LegacyWatchLaterRoutePaths = [`${LEGACY_WATCH_LATER_URL_FRAGMENT}/page/:page`, LEGACY_WATCH_LATER_URL_FRAGMENT];
const myPlaylistsTabs = MY_PLAYLISTS_TABS.join('|');
export const MyPlaylistsRoutePaths = [`${MY_PLAYLISTS_URL_FRAGMENT}/:tab(${myPlaylistsTabs})/page/:page`, `${MY_PLAYLISTS_URL_FRAGMENT}/page/:page`, `${MY_PLAYLISTS_URL_FRAGMENT}/:tab(${myPlaylistsTabs})?`];
export const WizardRoutePaths = [`${WIZARD_URL_FRAGMENT}/${HUBSPOT_SOFTWARE_INDEX}/:categoryGroup/:certsOnly(true|false)`, `${WIZARD_URL_FRAGMENT}/${HUBSPOT_SOFTWARE_INDEX}/:categoryGroup?/:category?/:certsOnly(true|false)?`, `${WIZARD_URL_FRAGMENT}/:categoryGroup/:certsOnly(true|false)`, `${WIZARD_URL_FRAGMENT}/:categoryGroup?/:category?/:certsOnly(true|false)?`];
export const Routes = () => {
  const showDevtools = useShowDevtools();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), showDevtools && /*#__PURE__*/_jsx(Devtools, {}), /*#__PURE__*/_jsx(NewUserLanding, {}), /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        component: RemoveTrailingSlash,
        path: "/*(/+)"
      }), /*#__PURE__*/_jsx(Route, {
        component: SoftwareDiscoveryIframe,
        path: `/${SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS}/:toolSlug?`
      }), /*#__PURE__*/_jsx(Route, {
        component: PracticeMode,
        path: PRACTICE_MODE_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(NamedRoute, {
        component: Wizard,
        name: PAGE_NAMES.WIZARD,
        path: WizardRoutePaths
      }), /*#__PURE__*/_jsx(NamedRoute, {
        component: TrackPageRouter,
        name: PAGE_NAMES.COURSE,
        path: [`${TRACKS_URL_FRAGMENT}/:trackId(\\d+)/:lessonId?/:contentId?`]
      }), /*#__PURE__*/_jsx(NamedRoute, {
        component: Lesson,
        name: PAGE_NAMES.LESSON,
        path: "/lessons/:lessonId/:contentId?"
      }), /*#__PURE__*/_jsx(NamedRoute, {
        component: AwardShareControls,
        exact: true,
        name: PAGE_NAMES.AWARD_SHARE,
        path: [SHARE_AWARD_URL_FRAGMENT, SHARE_AWARD_PREVIEW_URL_FRAGMENT]
      }), /*#__PURE__*/_jsx(Route, {
        component: RedirectToAwardShare,
        path: LEGACY_SHARE_AWARD_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(Route, {
        component: RedirectToNewOverview,
        path: LEGACY_OVERVIEW_URL
      }), /*#__PURE__*/_jsx(DashboardPageLayoutRoute, {
        component: Homepage,
        exact: true,
        headerSearch: true,
        name: PAGE_NAMES.CATALOG,
        path: "/",
        titleKey: "HOME"
      }), /*#__PURE__*/_jsx(DashboardPageLayoutRoute, {
        component: Catalog,
        headerSearch: true,
        name: PAGE_NAMES.CATALOG,
        path: RESULTS_URL_FRAGMENT,
        titleKey: "CATALOG"
      }), /*#__PURE__*/_jsx(DashboardPageLayoutRoute, {
        component: PartnerPage,
        headerSearch: true,
        name: PAGE_NAMES.PARTNER,
        path: PARTNER_TRACKS_URL_FRAGMENT,
        titleKey: "PARTNERS"
      }), /*#__PURE__*/_jsx(Route, {
        component: RedirectToMyTeamOverview,
        exact: true,
        path: LEGACY_MY_TEAM_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(DashboardPageLayoutRoute, {
        component: MyTeamOverview,
        exact: true,
        name: PAGE_NAMES.MY_TEAM,
        path: MY_TEAM_URL_FRAGMENT,
        titleKey: "MY_TEAM_OVERVIEW"
      }), /*#__PURE__*/_jsx(DashboardPageLayoutRoute, {
        component: MyTeamCertificationsIndex,
        exact: true,
        name: PAGE_NAMES.MY_TEAM,
        path: MY_TEAM_CERTIFICATIONS_URL_FRAGMENT,
        titleKey: "MY_TEAM_CERTIFICATIONS"
      }), /*#__PURE__*/_jsx(DashboardPageLayoutRoute, {
        component: MyTeamMembers,
        exact: true,
        name: PAGE_NAMES.MY_TEAM,
        path: MY_TEAM_MEMBERS_URL_FRAGMENT,
        titleKey: "MY_TEAM_MEMBERS"
      }), /*#__PURE__*/_jsx(NamedRoute, {
        component: EditProfile,
        exact: true,
        name: PAGE_NAMES.MY_PROFILE,
        path: `${PROFILE_URL_FRAGMENT}/edit`
      }), /*#__PURE__*/_jsx(NamedRoute, {
        component: UserProfile,
        exact: true,
        name: PAGE_NAMES.MY_TEAM,
        path: `${PROFILE_URL_FRAGMENT}/:userId`
      }), /*#__PURE__*/_jsx(NamedRoute, {
        component: MyProfile,
        exact: true,
        name: PAGE_NAMES.MY_PROFILE,
        path: PROFILE_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(NamedRoute, {
        component: MyLearningTabs,
        exact: true,
        name: PAGE_NAMES.MY_LEARNING,
        path: MyLearningRoutePath
      }), /*#__PURE__*/_jsx(NamedRoute, {
        exact: true,
        name: PAGE_NAMES.HUBSPOT_PLAYLISTS_ADMIN,
        path: HUBSPOT_PLAYLISTS_ADMIN_URL_FRAGMENT,
        children: /*#__PURE__*/_jsx(HubspotPlaylistsAdmin, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: MY_PLAYLISTS_URL_FRAGMENT,
        children: /*#__PURE__*/_jsxs(Switch, {
          children: [/*#__PURE__*/_jsx(NamedRoute, {
            exact: true,
            name: PAGE_NAMES.PLAYLISTS,
            path: MyPlaylistsRoutePaths,
            children: /*#__PURE__*/_jsx(SavedItemsLayout, {
              children: /*#__PURE__*/_jsx(MyPlaylists, {})
            })
          }), /*#__PURE__*/_jsx(NamedRoute, {
            component: Playlist,
            exact: true,
            name: PAGE_NAMES.PLAYLISTS,
            path: [PLAYLIST_URL_FRAGMENT, PLAYLIST_RESULTS_URL_FRAGMENT, PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT]
          })]
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: SAVED_ITEMS_URL_FRAGMENT,
        children: /*#__PURE__*/_jsx(Switch, {
          children: /*#__PURE__*/_jsx(NamedRoute, {
            component: RedirectToWatchLater,
            name: PAGE_NAMES.SAVED_ITEMS,
            path: LegacyWatchLaterRoutePaths
          })
        })
      }), /*#__PURE__*/_jsx(NamedRoute, {
        component: WatchLater,
        name: PAGE_NAMES.WATCH_LATER,
        path: WATCH_LATER_URL_FRAGMENT
      }), enviro.isQa() && /*#__PURE__*/_jsx(Route, {
        component: QaOnlyRoutes,
        path: "/qa-only"
      }), /*#__PURE__*/_jsx(Route, {
        component: RedirectToTracksWithQueryParams,
        path: "/tracks"
      }), /*#__PURE__*/_jsx(ShortContentRoute, {}), /*#__PURE__*/_jsx(DashboardPageLayoutRoute, {
        component: Homepage,
        headerSearch: true,
        name: PAGE_NAMES.CATALOG,
        titleKey: "HOME"
      })]
    }), /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        component: RedirectToAward,
        path: `(.*)${LEGACY_AWARD_URL_FRAGMENT}`
      }), /*#__PURE__*/_jsx(Route, {
        component: TrackAwardModalContainer,
        path: `(.*)${AWARD_URL_FRAGMENT}`
      })]
    }), /*#__PURE__*/_jsx(Route, {
      component: AchievementPreviewModal,
      path: SHARE_AWARD_PREVIEW_URL_FRAGMENT
    }), /*#__PURE__*/_jsx(Route, {
      component: EngagementTracking,
      path: `/tracks/:trackId(\\d+)`
    }), /*#__PURE__*/_jsx(Route, {
      component: EngagementTracking,
      path: `/lessons/:lessonId(\\d+)`
    }), /*#__PURE__*/_jsx(Route, {
      component: CreatePlaylist,
      path: `(.*)${CREATE_PLAYLIST_URL_FRAGMENT}/`
    }), /*#__PURE__*/_jsx(Route, {
      component: EditPlaylist,
      path: `(.*)${PLAYLIST_URL_FRAGMENT}${EDIT_PLAYLIST_URL_FRAGMENT}`
    }), /*#__PURE__*/_jsx(Route, {
      component: DuplicatePlaylist,
      path: `(.*)${PLAYLIST_URL_FRAGMENT}${DUPLICATE_PLAYLIST_URL_FRAGMENT}`
    }), /*#__PURE__*/_jsx(Route, {
      component: AssignPlaylist,
      path: `(.*)${ASSIGN_PLAYLIST_URL_FRAGMENT}`
    }), /*#__PURE__*/_jsx(NamedRoute, {
      component: MyTeamCertificationProfile,
      exact: true,
      name: PAGE_NAMES.MY_TEAM,
      path: `${MY_TEAM_URL_FRAGMENT}/certifications/:certificationId/:certificationStatus(active|expired|in-progress)`
    }), /*#__PURE__*/_jsx(NamedRoute, {
      component: RedirectToCertificationProfileDefaultTab,
      exact: true,
      name: PAGE_NAMES.MY_TEAM,
      path: `${MY_TEAM_URL_FRAGMENT}/certifications/:certificationId`
    }), /*#__PURE__*/_jsx(NamedRoute, {
      component: MyTeamCertificationsByTeam,
      exact: true,
      name: PAGE_NAMES.MY_TEAM,
      path: `${MY_TEAM_URL_FRAGMENT}/certifications-by-team/:certificationStatus(active|expired|in-progress)`
    }), /*#__PURE__*/_jsx(NamedRoute, {
      component: RedirectToCertificationsByTeamDefaultTab,
      exact: true,
      name: PAGE_NAMES.MY_TEAM,
      path: `${MY_TEAM_URL_FRAGMENT}/certifications-by-team`
    }), /*#__PURE__*/_jsx(Route, {
      component: ReactRouterScrollToTop,
      path: MY_TEAM_URL_FRAGMENT
    })]
  });
};
export default Routes;